import React, { useState } from 'react';
import './Header.css';
import heroImage1 from '../assets/img/1 (1).jpg';

const Header = () => {
  const [phone, setPhone] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Phone submitted:', phone);
    alert('Đăng ký thành công! Chúng tôi sẽ liên hệ với bạn sớm nhất.');
  };

  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              <span className="title-highlight">Quay Số May Mắn</span> Trúng Ngay Tiền Thật
              <br />
              <span className="title-sub">10 Triệu Đồng Đang Chờ Bạn!</span>
            </h1>
            <p className="hero-subtitle">
              Tham gia quay số may mắn miễn phí, trúng ngay tiền mặt. 
              <br />
              Hàng ngàn người đã trúng thưởng, bạn có muốn thử không?
            </p>
            <div className="trust-badges">
              <div className="badge">
                <span className="badge-icon">✓</span>
                <span>Đã có 250,000+ người chơi</span>
              </div>
              <div className="badge">
                <span className="badge-icon">💰</span>
                <span>Đã trao 15 tỷ đồng giải thưởng</span>
              </div>
              <div className="badge">
                <span className="badge-icon">🔒</span>
                <span>Uy tín - Bảo mật SSL</span>
              </div>
            </div>
            <form className="hero-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="phone-header" className="sr-only">Số điện thoại</label>
                <input
                  id="phone-header"
                  type="tel"
                  placeholder="Nhập số điện thoại của bạn"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                  className="phone-input"
                  aria-label="Nhập số điện thoại để đăng ký chơi game may mắn"
                  pattern="[0-9]{10,11}"
                  title="Vui lòng nhập số điện thoại hợp lệ (10-11 chữ số)"
                />
                <button type="submit" className="cta-button" aria-label="Đăng ký chơi game may mắn miễn phí">
                  CHƠI NGAY - MIỄN PHÍ
                </button>
              </div>
              <p className="form-note">
                Không cần thẻ tín dụng • Hoàn toàn miễn phí
              </p>
            </form>
          </div>
          <div className="hero-image">
            <div className="image-wrapper">
              <img src={heroImage1} alt="Game may mắn - Quay số trúng thưởng" loading="eager" />
              <div className="floating-badge">
                <span className="badge-text">MIỄN PHÍ</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-background-decoration"></div>
    </section>
  );
};

export default Header;

